import React, { FC } from "react";

import { AuthenticatedLayout } from "../../../layouts";
import { ClientDashboard } from "../../../components/Client/ClientDashboard/dashboard design 2/ClientDashboard";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

// import { ClientDashboard } from "../../../components/Client/ClientDashboard/dashboard/ClientDashboard";



// import { ClientDashboard } from "../../../components/Client/ClientDashboard";



// import { AccountantListContent } from "components";
// import { AuthenticatedLayout } from "layouts";
// import { AuthenticatedLayout } from "layouts/AuthenticatedLayout/AuthenticatedLayout";
// import { ClientDashboard } from "components/Client/ClientDashboard/ClientDashboard";
// import { ClientDashboard } from "components/Client/ClientDashboard";

export interface IClientDashboardPage {
	// employeeList: any
}

export const ClientDashboardPage: FC<IClientDashboardPage> = (
	props: IClientDashboardPage
) => {
	return (
		<AuthenticatedLayout
			pageTitle="Client Dashboard"
			pageTitleIcon={<DescriptionOutlinedIcon />}
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<ClientDashboard />}
		/>
	);
};
